var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.fullName,
    offset: 12,
    delay: { show: 300, hide: 100 },
    placement: 'right',
  }),expression:"{\n    content: fullName,\n    offset: 12,\n    delay: { show: 300, hide: 100 },\n    placement: 'right',\n  }"}],class:[
    'field-initials',
    {
      sender: _vm.isSender,
      'no-value': !_vm.hasValidatedValue,
      relative: _vm.scale,
    } ]},[_vm._v("\n  "+_vm._s(_vm.initials)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }